<template>
	<div class="invalid-feedback" v-if="validation.flags.invalid">
		{{validation.message}}
	</div>
	<!--<div class="valid-feedback" v-else-if="validation.flags.valid">
		{{validation.message}}
	</div>-->
</template>

<script>
	export default {
		name: "vee-message",
		props: {
			path: {
				type: String
			}
		},
		computed:{
			validation(){
				return this.$parent.vee(this.path);
			}
		}
	}
</script>

<style scoped>

</style>